import { NgModule } from "@angular/core";

import { SvgComponent } from "./svg.component";

@NgModule({
  imports: [SvgComponent],
  exports: [SvgComponent],
})
export class SvgModule {}
